<h1 mat-dialog-title>{{data.header}}</h1>
<div mat-dialog-content>
    <p>{{data.body}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Close</button>
</div>

